import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const userService = {
    getAllUsers, 
    getAllStaffs, 
    getUser
  };

const MODULE = {
    USER: 'public-users',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v2'


export function getAllUsers(filter) {

    const requestOptions = {
      params: {
        page: filter.pageNumber,
        size: filter.pageSize,
        is_locked: filter.isLocked,
        is_active: filter.isActive,
        ihextar_company: filter.iHextarCompany,
        company: filter.company, 
        id: filter.id
      }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
      if(word != null || word != '')
      {
        var searchParam = `search_words[${index}]`
        requestOptions.params[searchParam] = word
      }
    })
    
    return apiHelper(API_URL).get(`/${MODULE.USER}`, requestOptions)
}

export async function getUser(id) {
  return await apiHelper(API_URL).get(`/${MODULE.USER}/${id}`)
}

export function getAllStaffs(filter) {

  const requestOptions = {
    params: {
      page: filter.pageNumber,
      size: filter.pageSize,
      is_locked: filter.isLocked,
      is_active: filter.isActive,
      ihextar_company: filter.iHextarCompany
    }
  }

  let array = filter.searchArray
  array.forEach((word, index) => {
    if(word != null || word != '')
    {
      var searchParam = `search_words[${index}]`
      requestOptions.params[searchParam] = word
    }
  })
  
  return apiHelper(API_URL).get(`/${MODULE.USER}/public`, requestOptions)
}